var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYj(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "181.22487mm",
    height: "259.49857mm",
    viewBox: "0 0 181.22487 259.49857",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h-11.074v4.653H0v11.195l5.357 1.315v3.069l-23.374 4.172c-.96.173-1.745-.484-1.745-1.46v-51.256c0-.975.781-1.616 1.736-1.426L0-26.152Z",
    style: {
      fill: "#04a2e7",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(4.0375 0 0 -4.0375 79.79 98.643)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0-18.044-4.432v-12.509h11.081v-4.654h-11.081v-25.087l-5.357-1.065v-7.611L.006-61.382c.942-.241 1.716.36 1.716 1.331v58.702C1.722-.373.945.232 0 0",
    style: {
      fill: "#59c134",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "matrix(4.0375 0 0 -4.0375 174.272 11.454)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYj);
export default __webpack_public_path__ + "static/media/yj.943b8f15032d13d32156e9f3a6a1e4b6.svg";
export { ForwardRef as ReactComponent };